import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import { useForm } from 'react-hook-form';
import { BadgeList, Badge } from '../../reporting/reporting_utils/Badge';

const $ = window.$;

class FiltersSlideout extends HTMLElement {
  connectedCallback() {
    let table_name = this.getAttribute('data-table-name');
    this.innerHTML = `<div id="filters_slideout${table_name}"></div>`;
    ReactDOM.render(React.createElement(Filters, {table_name: table_name}), this.querySelector(`#filters_slideout${table_name}`));
  }
}

const defaultValues = {
  Active: false,
  'Call Recording': false,
  CallShield: false,
  'Call Treatments': false,
  'Text Enabled': false,
};

function BadgeListPortal(props) {
  if (document.querySelector(`.filter_badges_${props.table_name}`)) {
    return ReactDOM.createPortal(props.children, document.querySelector(`.filter_badges_${props.table_name}`));
  } else {
    return null;
  }
}

function Filters(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState(defaultValues);

  const { register, reset, handleSubmit, setValue } = useForm({ defaultValues });

  // Filters DataTable whenever applied filters change
  useEffect(() => {
    // Only run if table is visible or else DataTables throws an error
    if ($(`#${props.table_name}`).is(':visible')) {

      $.fn.dataTable.ext.search = [
        (settings, searchData, index, rowData) => {
          return (
            Object.values(appliedFilters)
              // Creates array of currently applied filter names
              .filter((value) => Boolean(value))
              // Returns true for current row if each column data
              // for the current filters returns a truthy value
              .every((filter) => {
                if (filter === 'status') {
                  return rowData[filter] === 1;
                } else {
                  return Boolean(rowData[filter]);
                }
              })
          );
        },
      ];

      $(`#${props.table_name}`).DataTable().draw();
    }
  }, [appliedFilters]);

  function applyFilters(formData) {
    setAppliedFilters(formData);
    setIsOpen(false);
  }

  function clearFilters() {
    reset();
    setAppliedFilters(defaultValues);
    setIsOpen(false);
  }

  function handleBadgeRemove(filterName) {
    setValue(filterName, false);
    setAppliedFilters({ ...appliedFilters, [filterName]: false });
  }

  return (
    <>
      <BadgeListPortal table_name={props.table_name}>
        {Object.values(appliedFilters).some((val) => Boolean(val)) ? (
          <BadgeList
            style={{ marginBottom: 10, float: 'left', marginTop: 2 }}
            title='Applied Filters'
          >
            {Object.entries(appliedFilters).map(([name, value]) => {
              if (value) {
                return (
                  <Badge
                    key={name}
                    label={name}
                    removable
                    onRemove={() => handleBadgeRemove(name)}
                  />
                );
              }
            })}
          </BadgeList>
        ) : null}
      </BadgeListPortal>
      <CSSTransition in={isOpen} timeout={300} classNames='backdrop' appear>
        <div onClick={() => setIsOpen(false)}></div>
      </CSSTransition>
      <div className={`sidedrawer ${isOpen ? 'open' : ''}`}>
        <div
          onClick={() => {
            setIsOpen((prevOpen) => !prevOpen);
          }}
          className='filter-button'
          role='button'
        >
          <svg
            style={{ height: '20px', width: '20px' }}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 12 12'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M11.5 0c.273 0 .5.272.5.6v1.2c0 .328-.227.6-.5.6H.5c-.273 0-.5-.272-.5-.6V.6C0 .272.227 0 .5 0h11ZM9.907 5.4c0-.328-.148-.6-.326-.6H2.42c-.179 0-.326.272-.326.6v1.2c0 .328.147.6.326.6H9.58c.178 0 .326-.272.326-.6V5.4ZM8.51 10.2c0-.328-.095-.6-.209-.6H3.698c-.115 0-.21.272-.21.6v1.2c0 .328.095.6.21.6h4.604c.114 0 .21-.272.21-.6v-1.2Z'
              fill='#434A54'
            />
          </svg>
        </div>
        <div className='sidedrawer-content'>
          <div style={{ paddingLeft: '30px', paddingRight: '30px' }}>
            <div className='sidedrawer-header'>
              <h2>
                <svg
                  style={{
                    height: '10px',
                    width: '10px',
                    marginRight: '5px',
                    display: 'inline-block',
                  }}
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 12 12'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M11.5 0c.273 0 .5.272.5.6v1.2c0 .328-.227.6-.5.6H.5c-.273 0-.5-.272-.5-.6V.6C0 .272.227 0 .5 0h11ZM9.907 5.4c0-.328-.148-.6-.326-.6H2.42c-.179 0-.326.272-.326.6v1.2c0 .328.147.6.326.6H9.58c.178 0 .326-.272.326-.6V5.4ZM8.51 10.2c0-.328-.095-.6-.209-.6H3.698c-.115 0-.21.272-.21.6v1.2c0 .328.095.6.21.6h4.604c.114 0 .21-.272.21-.6v-1.2Z'
                    fill='#434A54'
                  />
                </svg>
                Filters:
              </h2>
              <button
                onClick={() => setIsOpen(false)}
                type='button'
                className='close'
                aria-label='Close'
              >
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
          </div>
          <form onSubmit={handleSubmit(applyFilters)} className='sidedrawer-form'>
            <div>
              <div className='flex col-xs-12 col-sm-6 form-group'>
                <div className='col-xs-5 no-gutters'>
                  <label htmlFor='status'>Active</label>
                </div>
                <div className='col-xs-7 no-gutters'>
                  <input
                    {...register('Active')}
                    style={{ marginLeft: '5px' }}
                    type='checkbox'
                    value='status'
                    id='status'
                  />
                </div>
              </div>
              <div className='flex col-xs-12 col-sm-6 form-group'>
                <div className='col-xs-5 no-gutters'>
                  <label htmlFor='enable_call_recording'>Call Recording</label>
                </div>
                <div className='col-xs-7 no-gutters'>
                  <input
                    {...register('Call Recording')}
                    style={{ marginLeft: '5px' }}
                    type='checkbox'
                    value={props.table_name == 'campaigns_container' ? 'enable_call_recording' : 'call_recording'}
                    id='enable_call_recording'
                  />
                </div>
              </div>
              <div className='flex col-xs-12 col-sm-6 form-group'>
                <div className='col-xs-5 no-gutters'>
                  <label htmlFor='callshield'>CallShield</label>
                </div>
                <div className='col-xs-7 no-gutters'>
                  <input
                    {...register('CallShield')}
                    style={{ marginLeft: '5px' }}
                    type='checkbox'
                    value={props.table_name == 'campaigns_container' ? 'callshield' : 'call_shield'}
                    id='callshield'
                  />
                </div>
              </div>
              <div className='flex col-xs-12 col-sm-6 form-group'>
                <div className='col-xs-5 no-gutters'>
                  <label htmlFor='target_id'>Call Treatments</label>
                </div>
                <div className='col-xs-7 no-gutters'>
                  <input
                    {...register('Call Treatments')}
                    style={{ marginLeft: '5px' }}
                    type='checkbox'
                    value='target_id'
                    id='target_id'
                  />
                </div>
              </div>
              <div className='flex col-xs-12 col-sm-6 form-group'>
                <div className='col-xs-5 no-gutters'>
                  <label htmlFor='did_texting_enabled'>Text Enabled</label>
                </div>
                <div className='col-xs-7 no-gutters'>
                  <input
                    {...register('Text Enabled')}
                    style={{ marginLeft: '5px' }}
                    type='checkbox'
                    value={props.table_name == 'campaigns_container' ? 'did_texting_enabled' : 'text_enabled'}
                    id='did_texting_enabled'
                  />
                </div>
              </div>
            </div>
            <div className='submit-buttons-container col-xs-12'>
              <button onClick={clearFilters} type='button' className='btn btn-default'>
                Clear
              </button>
              <button style={{ marginLeft: '1rem' }} type='submit' className='btn btn-primary'>
                Apply
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

customElements.define('filters-slideout', FiltersSlideout);
